<div class="image-canvas h100 w100">
    <ng-container *ngIf="!backgroundImage?.width || !imageLoaded">
        <image-placeholder [hasLoaded]="imageLoaded" [size]="'large'" [noImageMessage]="'Image not found'"></image-placeholder>
    </ng-container>
    <div class="annotation-interface" ref="wrapper">
        <div #canvasWrapper class="canvas-wrapper">
            <canvas id="{{canvasId}}"></canvas>
        </div>
    </div>
</div>